import React, { Component } from 'react'
import { connect } from 'react-redux'

import Snackbar from 'material-ui/Snackbar'
import RaisedButton from 'material-ui/RaisedButton'

import dataActions from 'actions/dataActions'

let select = (state) => ({
	prompt: state.prompt
})

export class prompt extends Component{
	render(){
		let prompt = this.props.prompt == "close"
		let standAlone = false
		return(
			<Snackbar
	          open={!!prompt}
	          message="Please save or discard your changes first"
	          autoHideDuration={4000}
	          onRequestClose={() => {
				  this.props.CLOSE_PROMPT()
			  }}
	        />
		)
	}
}

export default connect(select, dataActions)(prompt)

// export default (o) => {
// 	let actions = [
// 		<RaisedButton
// 			label="OK"
// 			primary={true}
// 			style={{margin:"0 20px"}}
// 			onTouchTap={o.abort}
// 		/>
// 	];
// 	return(
//         <Dialog
//           title="You have unsaved data"
//           actions={actions}
//           modal={true}
//           open={o.open}
// 		  actionsContainerStyle={{
// 			  paddingBottom: "20px"
// 		  }}
//         >
//           Please save or discard your changes first
//         </Dialog>
// 	)
// }



// WEBPACK FOOTER //
// ./src/components/Prompt.js